class AuthService {

    authenticated: any;

    user: any;

    constructor() {
        let user = localStorage.getItem("rumbosUser");
        let extraInfo = localStorage.getItem("userLogged");
        this.authenticated = !!user ? true : false;

        if (!!user) this.user = JSON.parse(user);
        if (!!user && !!extraInfo) this.user.detail = JSON.parse(extraInfo);
    }

    isAuthenticated = (): boolean => this.authenticated;

    getLoggedUser = (): any => this.user;

    hasAuthority = (authority: any): boolean => {
        return this.user.roles.some((it: any) => it == authority);
    };

    hasAnyAuthorities = (authorities: any[]): boolean => {
        let hasAny = false;
        if(!!authorities && authorities.length>0){
            authorities.forEach(name => {
                if(this.hasAuthority(name)){                   
                    hasAny = true;
                }
            });
        }

        return hasAny;
    };

    formatRol= (authority:string) => {
        switch(authority){
            case 'ROLE_ADMIN':
                return 'Admin';
            case 'ROLE_USER_ADMIN':
                return 'Admin Empresa';
            case 'ROLE_USER':
                return 'User Empresa';
        }
    }

    formatTipoNoti = (tipoNotificacion:string) => {
        switch(tipoNotificacion){
            case 'TASK_MAIL':
                return 'Enviar Mail';
            case 'TASK_TELEGRAM':
                return 'Telegram';
        }
    }



    userLoginSucess = () => {
        let user = localStorage.getItem("rumbosUser");
        let extraInfo = localStorage.getItem("userLogged");

        this.authenticated = !!user ? true : false;

        if (!!user) this.user = JSON.parse(user);
        if (!!user && !!extraInfo) this.user.detail = JSON.parse(extraInfo);
    }

    userLogout = () => {
        this.authenticated = false;
        this.user = undefined;
    }

}

const authService = new AuthService();

export default authService;